import React, { useState, useCallback } from 'react';
import HomeSectionTransactionTable from './HomeSectionTransactionTable';
import CSVDownloadButton from './common/CSVDownloadButton';
import CreditLineFilter from './common/CreditLineFilter';
import { transactionCSVColumns } from '../utils/csvColumns';
import { HomeTableProps } from '../utils';
import styles from '../styles/components/TransactionTableWithCSV.module.scss';

interface TransactionTableWithCSVProps {
  filter: string;
  csvFilename: string;
  showTabs?: boolean;
}

function TransactionTableWithCSV({ filter, csvFilename, showTabs = false }: TransactionTableWithCSVProps) {
  const [transactionData, setTransactionData] = useState<HomeTableProps[]>([]);
  const [selectedCreditLineId, setSelectedCreditLineId] = useState<number | undefined>(undefined);

  const handleDataChange = useCallback((data: HomeTableProps[]) => {
    setTransactionData(data);
  }, []);

  const getTableTitle = (filterType: string) => {
    switch (filterType) {
      case 'credit-fee-payments':
        return 'Fee Payment History';
      case 'credit-transactions':
        return 'Credit Transactions';
      case 'repayments':
        return 'Repayments';
      default:
        return 'All Transactions';
    }
  };

  return (
    <div className={styles.tableWithCSV}>
      <div className={styles.tableHeader}>
        <h2 className={styles.tableTitle}>
          {getTableTitle(filter)}
        </h2>
        <CSVDownloadButton
          data={transactionData}
          columns={transactionCSVColumns}
          filename={csvFilename}
          className={styles.csvButton}
        />
      </div>

      {/* Filter Controls */}
      <div className={styles.filterControls}>
        <CreditLineFilter
          selectedCreditLineId={selectedCreditLineId}
          onCreditLineChange={setSelectedCreditLineId}
          className={styles.creditLineFilter}
        />
      </div>
      
      <div className={styles.tableContent}>
        <HomeSectionTransactionTable 
          filter={filter}
          creditLineId={selectedCreditLineId}
          onDataChange={handleDataChange}
        />
      </div>
    </div>
  );
}

export default TransactionTableWithCSV;
